import { typography, size, mediaQueries } from '@everlywell/leaves';
import styled from 'styled-components';

export const DisplayText = styled.h2`
  ${typography.displayText};
  margin-bottom: ${size.xl1}px;
  text-align: left;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: 4.062rem;
    text-align: center;
  }
`;
